<template>
  <div class="detail-container" style="margin-top: -250px">
    <detailHeader :detail="detail" :category-info="categoryInfo"></detailHeader>
    <div class="mt-10 flex">
      <div v-if="showPriceContent" class="relative mr-10 w-486">
        <priceContent v-if="compareData.platformMarket && showPriceContent" :category-info="categoryInfo" :detail="detail" :compare-data="compareData"></priceContent>
        <el-skeleton v-else style="width: 486px; background-color: white; padding: 10px; border-radius: 10px">
          <template #template>
            <el-skeleton-item variant="rect" style="width: 220px; height: 90px; margin-right: 10px" />
            <el-skeleton-item variant="rect" style="width: 220px; height: 90px" />
            <div class="my-10">
              <el-skeleton-item variant="p" style="width: 50%" />
              <div style="display: flex; align-items: center; justify-items: space-between">
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="width: 30%" />
              </div>
            </div>
            <div class="my-10">
              <el-skeleton-item variant="p" style="width: 50%" />
              <div style="display: flex; align-items: center; justify-items: space-between">
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="width: 30%" />
              </div>
            </div>
            <div class="my-10">
              <el-skeleton-item variant="p" style="width: 50%" />
              <div style="display: flex; align-items: center; justify-items: space-between">
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="width: 30%" />
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>
      <div v-if="showChart" :style="{ width: !showPriceContent ? '1400px' : '904px' }" class="relative rounded-[10px] bg-white pt-20" style="transition: all linear 0.4s">
        <el-tabs v-model="activeTab" class="my-tabs" @tab-change="tab => (tabStorage = tab)">
          <el-tab-pane :label="$t('饰品走势')" name="trend"></el-tab-pane>
          <el-tab-pane :label="$t('当前在售')" name="onsale"></el-tab-pane>
          <el-tab-pane v-if="hasWearList.indexOf(detail.itemType) > -1" :label="$t('磨损排行')" name="wearrank"></el-tab-pane>
        </el-tabs>
        <div style="position: absolute; right: 20px; top: 20px">
          <i v-if="!showPriceContent" class="iconfont icon-suofang-xiao cursor-pointer" @click="reshowPriceContent"></i>
          <i v-if="showPriceContent" class="iconfont icon-fangda cursor-pointer" @click="hidePriceContent"></i>
        </div>
        <div v-if="activeTab === 'trend'">
          <ClientOnly>
            <charts
              v-if="trendData.data.trendList.length || !chartLoading"
              :tend-data="trendData"
              :submit-param="{
                itemId: detail?.itemId
              }"
              :echart-param="{
                typeVal: detail?.itemId
              }"
              :default-filter="filterData"
              :detail="detail"
              :width="showPriceContent ? '904px' : '1400px'"
              @show-details="handleShowDetails"
            ></charts>
            <div v-else>
              <el-skeleton :animated="true" style="width: 904px; height: 500px; background-color: white; border-radius: 10px">
                <template #template>
                  <el-skeleton-item variant="rect" style="width: 100%; height: 100%" />
                </template>
              </el-skeleton>
            </div>
          </ClientOnly>
        </div>
        <div v-show="activeTab === 'onsale'">
          <saleList :item-id="detail?.itemId"></saleList>
        </div>
        <div v-if="activeTab === 'wearrank'" class="rounded-[10px]">
          <wearRank :markethashname="marketHashName" :list="wearRankList" :loading="loading" :page-loading="pageLoading" @load-more="rankloadMore"></wearRank>
        </div>
      </div>
    </div>
    <div v-if="showTransactionDetail">
      <ClientOnly>
        <transactionDetail :dialog-visible="showTransactionDetail" :detail="detail" :transaction-data="transactionData" @close="showTransactionDetail = false" />
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
import detailHeader from './itemDetailComponents/detail-header.vue'
import priceContent from './itemDetailComponents/price-content.vue'
import saleList from './itemDetailComponents/saleList.vue'
import wearRank from './itemDetailComponents/wearRank.vue'
import charts from './itemDetailComponents/charts.vue'
import transactionDetail from './itemDetailComponents/transactionDetail.vue'

import { getItemDetailWithHashName, getMarketCompare, getRelateList, getTypeTrend, getWearRank } from '~~/api/steam.js'

const { t } = useI18n()
const $t = t
const route = useRoute()
const hasWearList = [
  'CSGO_Type_SniperRifle',
  'CSGO_Type_Rifle',
  'CSGO_Type_Pistol',
  'CSGO_Type_SMG',
  'CSGO_Type_Shotgun',
  'CSGO_Type_Knife',
  'CSGO_Type_Machinegun',
  'Type_Hands',
  'CSGO_Type_Equipment'
]
const tabStorage = useLocalStorage('detail-content-tab')
const activeTab = ref(tabStorage.value ?? 'trend')
const transactionData = ref({})
const showPriceContent = ref(true)
const showChart = ref(true)
const marketHashName = route.params.marketHashName

let query = ref({
  appId: 730,
  marketHashName
})

const detail = ref({})
const [{ data: detailRes }, { data: categoryInfo }] = await Promise.all([getItemDetailWithHashName(query), getRelateList(query)])
detail.value = detailRes
useHead({
  title: $t(`{itemname}-CS2饰品价格走势-SteamDT`, { itemname: detail.value?.name }),
  meta: [
    {
      name: 'description',
      content: $t(`SteamDt为您提供{itemname}饰品的趋势分析、成交量、新增量、换手率、持有人数、挂刀比例及价格走势等数据,更多CS2饰品数据就上SteamDt。`, {
        itemname: detail.value?.name
      })
    },
    { name: 'keywords', content: $t(`{itemname},{itemname}价格走势,{itemname}趋势分析,CS2饰品数据,SteamDT`, { itemname: detail.value?.name }) }
  ]
})
const chartStorage = useLocalStorage('detail-chart')
const chartObj = chartStorage.value ? JSON.parse(chartStorage.value) : {}
const filterData = reactive({
  showType: chartObj.showType || 'charts',
  platform: route.query?.platform || chartObj.platform || 'ALL',
  typeDay: route.query?.days || chartObj.typeDay?.value || '1'
})

const submitData = {
  itemId: detail.value.itemId,
  platform: filterData.platform,
  typeDay: filterData.typeDay,
  dateType: 3
}

const trendData = ref({
  data: {
    trendList: []
  }
})
const chartLoading = ref(false)
const compareData = ref([])
const wearRankList = ref([])
for (let trendItem of trendData.value.data.trendList) {
  const tempObj = {
    endTime: trendItem[0],
    sellPrice: trendItem[1],
    sellCount: trendItem[2],
    biddingPrice: trendItem[3],
    biddingCount: trendItem[4],
    transactionAmount: trendItem[5],
    transactionCount: trendItem[6]
  }
  trendItem = tempObj
}
const tempArr = []
for (const item of detail.value.sellingPriceList) {
  if (item.price) {
    tempArr.push(item.price)
  }
}
if (tempArr.length > 0) {
  detail.value.lowestPrice = Math.min.apply(null, tempArr)
} else {
  detail.value.lowestPrice = 0
}

detail.value.updateTime = Math.max.apply(
  null,
  detail.value.sellingPriceList.map(item => item.updateTime)
)
const showTransactionDetail = ref(false)

onMounted(async () => {
  if (hasWearList.indexOf(detail.value.itemType) > -1) {
    getRankList()
  }
  chartLoading.value = true
  getTypeTrend(submitData).then(res => {
    trendData.value.data.trendList = res.data
    chartLoading.value = false
  })
  getMarketCompare(submitData).then(res => {
    res.data.platformMarket = res.data.platformMarket.filter(item => item.sellCount > 0)
    compareData.value = res.data
  })
})
// 成交详情弹窗
function handleShowDetails(data) {
  transactionData.value = data
  showTransactionDetail.value = true
}
let loading = ref(false)

let pageLoading = ref(false)

let pageQuery = ref({
  pageNum: 1,
  pageSize: 10,
  hashName: marketHashName
})
// 获取磨损排行
function getRankList(reset) {
  loading.value = true
  pageLoading.value = true
  if (pageQuery.value.lastId === null) {
    return false
  }
  getWearRank(pageQuery).then(res => {
    loading.value = false
    pageLoading.value = false

    for (let i = 0; i < res.data?.list.length; i++) {
      res.data.list[i].rankIndex = (pageQuery.value.pageNum - 1) * pageQuery.value.pageSize + i + 1
    }
    wearRankList.value = wearRankList.value.concat(res.data?.list)
    pageQuery.value.lastId = res.data.nextToken
  })
}
function rankloadMore() {
  if (loading.value) {
    return false
  }

  pageQuery.value.pageNum++
  getRankList()
}

const hidePriceContent = () => {
  showPriceContent.value = false
}
const reshowPriceContent = () => {
  showPriceContent.value = true
}
</script>

<style scoped lang="scss">
.detail-container {
  :deep(.el-divider) {
    border-color: #eff1f5;
  }
}
/* Add your custom styles here */
.my-tabs {
  :deep(.el-tabs__header) {
    margin-bottom: 0;
  }
  :deep(.el-tabs__nav-wrap) {
    &::after {
      height: 1px;
    }
  }
  :deep(.el-tabs__item) {
    padding-left: 20px !important;
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
